import amplitude from 'amplitude-js'

const options = {}
amplitude.getInstance().init(process.env.VUE_APP_AMPLITUDE, null, options)

export const logEvent = (eventName, eventProperties) => {
  amplitude.getInstance().logEvent(eventName, eventProperties)
}
